export default __webpack_public_path__ + "static/media/banana-boat.3f456b80.svg";